// Module
var code = "<html> <head></head> <body class=\"%experimentVersion%\" style=\"margin:0;padding:0\"> <div id=\"cta\"> <div class=\"textLabel\"> <label>%ctaLabel%</label> </div> <div class=\"icon\"></div> <div class=\"cross\"> <div class=\"line\"></div> <div class=\"line\"></div> </div> </div> </body> </html> ";
// Exports
export default code;